import PropTypes from 'prop-types';
import { memo, Component, useCallback } from 'react';
import identity from 'transmute/identity';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { callIfPossible } from 'UIComponents/core/Functions';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ContentTypeaheadContainer from './ContentTypeaheadContainer';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default (_ref => {
  let {
    Button,
    getNewLinkUrl,
    Header,
    manageUrl,
    onInsertContent,
    onlyRenderContent = false,
    onOpenPopover,
    PopoverComponent = Popover,
    PopoverEmptyState,
    PopoverErrorState,
    popoverPlacement = 'bottom',
    popoverTestKey,
    portalId,
    search,
    searchPlaceHolder,
    titleMessage: titleKey,
    tracker = identity,
    transformData = identity
  } = _ref;
  function ContentButtonContents({
    // @ts-expect-error ts-migrate FIXME
    open,
    // @ts-expect-error ts-migrate FIXME
    toggleOpen,
    // @ts-expect-error ts-migrate FIXME
    onOpenChange,
    // @ts-expect-error ts-migrate FIXME
    onContentChange
  }) {
    const renderContent = useCallback(() => /*#__PURE__*/_jsxs(View, {
      paddingBlockStart: "300",
      "data-test-id": "content-popover-container",
      children: [Header && /*#__PURE__*/_jsx(Header, {
        portalId: portalId,
        manageUrl: manageUrl,
        titleMessage: /*#__PURE__*/_jsx(FormattedMessage, {
          message: titleKey
        }),
        getNewLinkUrl: getNewLinkUrl
      }), /*#__PURE__*/_jsx(ContentTypeaheadContainer, {
        ErrorState: PopoverErrorState,
        EmptyState: PopoverEmptyState,
        onChange: onContentChange,
        portalId: portalId,
        search: search,
        transformData: transformData,
        searchPlaceHolder: searchPlaceHolder
      })]
    }), [onContentChange]);
    return /*#__PURE__*/_jsx(PopoverComponent, {
      open: open,
      closeOnOutsideClick: true,
      onOpenChange: onOpenChange,
      inlineSize: "460px",
      Content: renderContent,
      placement: popoverPlacement,
      "data-test-id": popoverTestKey,
      children: /*#__PURE__*/_jsx(Button, {
        active: open,
        onClick: toggleOpen
      })
    });
  }
  const MemoizedContentButtonContents = /*#__PURE__*/memo(ContentButtonContents);
  class ContentButton extends Component {
    constructor(props) {
      super(props);
      this.handleContentChange = this.handleContentChange.bind(this);
      this.handleOpenChange = this.handleOpenChange.bind(this);
      this.renderContent = this.renderContent.bind(this);
      this.setState = this.setState.bind(this);
      this.toggleOpen = this.toggleOpen.bind(this);
      this.state = {
        open: false
      };
    }
    toggleOpen() {
      // @ts-expect-error ts-migrate FIXME
      this.setState(({
        open
      }) => {
        if (!open && typeof onOpenPopover === 'function') {
          onOpenPopover();
        }
        return {
          open: !open
        };
      });
    }

    // @ts-expect-error ts-migrate FIXME
    handleContentChange({
      id,
      htmlBody,
      version
    }) {
      const {
        // @ts-expect-error ts-migrate FIXME
        editorState,
        // @ts-expect-error ts-migrate FIXME
        insertContent,
        // @ts-expect-error ts-migrate FIXME
        onClose,
        // @ts-expect-error ts-migrate FIXME
        useProsemirror
      } = this.props;
      onInsertContent({
        fromPopover: true
      });
      if (!useProsemirror) {
        const currentSelection = editorState.getSelection();
        tracker('inserted-content-from-popover');
        const start = currentSelection.getStartOffset();
        const length = currentSelection.getEndOffset() - start;
        insertContent({
          id,
          htmlBody,
          length,
          offset: start
        });
      } else {
        insertContent({
          id,
          htmlBody,
          version
        });
      }
      this.setState({
        open: false
      });
      callIfPossible(onClose);
    }
    handleOpenChange(e) {
      this.setState({
        open: e.target.value
      });
    }
    renderContent() {
      return /*#__PURE__*/_jsxs("div", {
        "data-test-id": "content-popover-container",
        children: [Header && /*#__PURE__*/_jsx(Header, {
          portalId: portalId,
          manageUrl: manageUrl,
          titleMessage: /*#__PURE__*/_jsx(FormattedMessage, {
            message: titleKey
          }),
          getNewLinkUrl: getNewLinkUrl
        }), /*#__PURE__*/_jsx(ContentTypeaheadContainer, {
          ErrorState: PopoverErrorState,
          EmptyState: PopoverEmptyState,
          onChange: this.handleContentChange,
          portalId: portalId,
          search: search,
          transformData: transformData,
          searchPlaceHolder: searchPlaceHolder
        })]
      });
    }
    render() {
      if (onlyRenderContent) {
        return this.renderContent();
      }
      // @ts-expect-error ts-migrate FIXME
      const {
        open
      } = this.state;
      return /*#__PURE__*/_jsx(MemoizedContentButtonContents, {
        open: open,
        onOpenChange: this.handleOpenChange,
        toggleOpen: this.toggleOpen,
        onContentChange: this.handleContentChange
      });
    }
  }
  // @ts-expect-error ts-migrate FIXME
  ContentButton.propTypes = {
    editorState: PropTypes.object,
    insertContent: PropTypes.func.isRequired,
    onClose: PropTypes.func,
    useProsemirror: PropTypes.bool
  };
  return ContentButton;
});